import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Navigation from "./Navigation";

import WelcomeTab from "./pages/WelcomeTab";
import CommissionsTab from "./pages/CommissionsTab";
import GalleryTab from "./pages/GalleryTab";
import EventsTab from "./pages/EventsTab";
import TestimonialsTab from "./pages/TestimonialsTab";

import 'bootstrap/dist/css/bootstrap.css';

function App() {
  return (
    <Router>
      <div className="d-flex flex-column vh-100">
        <Navigation />

        <div className="flex-grow-1 overflow-auto bg-light">
          <Routes>
            <Route exact path='/'       element={<WelcomeTab/>} />
            <Route path='/commissions'  element={<CommissionsTab/>} />
            <Route path='/gallery'      element={<GalleryTab />} />
            <Route path='/events'       element={<EventsTab/>} />
            <Route path='/testimonials' element={<TestimonialsTab/>} />
          </Routes>
        </div>
      </div>
    </Router>
  );
}

export default App;
